module.exports = __webpack_public_path__ + "static/media/kwell-512.9424f28a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/kwell-512.png
// module id = 773
// module chunks = 0